import { FwButton } from '@freshworks/crayons/react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSchemaPermissions } from 'hooks';
import customObjectImage from '../../../images/custom-object-icon.svg';
import { Header } from 'UI';

const EntityListHeader = props => {
  const { onCreateNewObjectHandler } = props;
  const { t } = useTranslation();
  const { hasCreatePermission: hasSchemaCreatePermission } = useSchemaPermissions();
  return (
    <div className="fw-mb-12">
      <Header isLoading={false} heading={t('entities.customObjects')} description={t('entities.description')} image={customObjectImage}>
        {hasSchemaCreatePermission && (
          <FwButton onFwClick={onCreateNewObjectHandler} color="primary">
            {t('entities.createObject')}
          </FwButton>
        )}
      </Header>
    </div>
  );
};

export default EntityListHeader;
